// Shared rich-text-editor constants with no module dependencies, so both the CKEditor plugin
// and the widget-snapshot helper can reference them without forming an import cycle.
export const WIDGET_SNAPSHOT_CLASS = 'cke-widget-snapshot';
